export default __webpack_public_path__ + "static/media/user.274f6916.png";